var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        { attrs: { data: _vm.rows, "empty-text": _vm.emptyText, border: "" } },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("operationCenter.ind"),
              align: "center",
              width: "60px",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          (_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("orderCenterCont.TheOrderNumber"),
              "show-overflow-tooltip": true,
              align: "left",
              "min-width": "160",
              prop: "orderNumber",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      [
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "top",
                              "popper-class": "copy",
                              trigger: "hover",
                            },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: {
                                  color: "black",
                                  "font-size": "12px",
                                  padding: "2px",
                                },
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.copy(scope.row.orderNumber)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("orderDetails.copy")) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "is-click-column",
                                attrs: { slot: "reference" },
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit("detail", scope.row)
                                  },
                                },
                                slot: "reference",
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(scope.row.orderNumber) + " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("orderLogAddress.result"),
              "min-width": "170",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.tagType(
                            scope.row.receiveAddressCheckResult
                          ),
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.resultLabel(
                                scope.row.receiveAddressCheckResult
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("newOrder.waybillNumber"),
              "show-overflow-tooltip": true,
              align: "left",
              "min-width": "160",
              prop: "waybillNumber",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      [
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "top",
                              "popper-class": "copy",
                              trigger: "hover",
                            },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: {
                                  color: "black",
                                  "font-size": "12px",
                                  padding: "2px",
                                },
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.copy(scope.row.waybillNumber)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("orderDetails.copy")) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                attrs: { slot: "reference" },
                                slot: "reference",
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(scope.row.waybillNumber) + " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("GlobalSetObj.serviceLogistics"),
              "min-width": "160",
              prop: "logisticsNumber",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      [
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "top",
                              "popper-class": "copy",
                              trigger: "hover",
                            },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: {
                                  color: "black",
                                  "font-size": "12px",
                                  padding: "2px",
                                },
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.copy(scope.row.logisticsNumber)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("orderDetails.copy")) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                attrs: { slot: "reference" },
                                slot: "reference",
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(scope.row.logisticsNumber) + " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("operationCenter.client"),
              "show-overflow-tooltip": true,
              align: "left",
              "min-width": "160",
              prop: "customerName",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("div", [_vm._v(_vm._s(scope.row.customerName))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("placeOrder.customerNumber"),
              "show-overflow-tooltip": true,
              align: "left",
              "min-width": "160",
              prop: "customerNumber",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("div", [_vm._v(_vm._s(scope.row.customerNumber))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("uploadFile.senderPostalCode"),
              "min-width": "150",
              prop: "senderZipcode",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.receivingState"),
              "min-width": "150",
              prop: "receiveState",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.receivingCity"),
              "min-width": "150",
              prop: "receiveCity",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("uploadFile.recipientPostalCode"),
              "min-width": "150",
              prop: "receiveZipcode",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("orderCenterCont.WhetherSuccessful"),
              "show-overflow-tooltip": true,
              align: "center",
              "min-width": "120",
              prop: "state",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.state === _vm.states.FAILURE
                      ? _c("el-tag", { attrs: { type: "danger" } }, [
                          _vm._v(
                            " " + _vm._s(_vm.$t("operationCenter.fail")) + " "
                          ),
                        ])
                      : _vm._e(),
                    scope.row.state === _vm.states.SUCCESS
                      ? _c("el-tag", { attrs: { type: "success" } }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("operationCenter.succeed")) +
                              " "
                          ),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("GlobalSetObj.ReasonForFailure"),
              prop: "failureMessage",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("orderCenterCont.CreationTime"),
              "show-overflow-tooltip": true,
              align: "left",
              "min-width": "180",
              prop: "createTime",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("orderCenterCont.AnjunDatagram"),
              "show-overflow-tooltip": false,
              align: "left",
              "min-width": "200",
              prop: "dealedRequestParams",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-tooltip", { attrs: { placement: "top" } }, [
                      _c(
                        "pre",
                        {
                          staticStyle: {
                            "max-height": "400px",
                            overflow: "auto",
                          },
                          attrs: { slot: "content" },
                          slot: "content",
                        },
                        [
                          _vm._v(
                            "                " +
                              _vm._s(scope.row.responseParams) +
                              "\n              "
                          ),
                        ]
                      ),
                      _c("div", { staticClass: "paramsStyle" }, [
                        _vm._v(_vm._s(scope.row.responseParams)),
                      ]),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("orderCenterCont.CustomerDatagram"),
              "show-overflow-tooltip": false,
              align: "left",
              "min-width": "200",
              prop: "requestParams",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-tooltip", { attrs: { placement: "top" } }, [
                      _c(
                        "pre",
                        {
                          staticStyle: {
                            "max-height": "400px",
                            overflow: "auto",
                          },
                          attrs: { slot: "content" },
                          slot: "content",
                        },
                        [
                          _vm._v(
                            "                " +
                              _vm._s(scope.row.requestParams) +
                              "\n              "
                          ),
                        ]
                      ),
                      _c("div", { staticClass: "paramsStyle" }, [
                        _vm._v(_vm._s(scope.row.requestParams)),
                      ]),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("orderCenterCont.operation"),
              fixed: "right",
              width: "140",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("detail", scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("orderCenterCont.ViewDetails")))]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }